export const ref = {
  gallery: document.querySelector('.gallery'),
  pagination: document.querySelector('.tui-pagination'),
  form: document.querySelector('form'),
  errorString: document.querySelector('.search-error'),
  tooltip: document.querySelector('.js-tooltiptext'),
};
